import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
  const phoneNumber = "27836351377";
  const message = encodeURIComponent("Hi SecureFlex! I'd like to learn more about your platform.");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center gap-2 sm:bottom-6 animate-scale-in" style={{ animationDelay: "1.5s", animationFillMode: "backwards" }}>
      <span className="rounded-full bg-foreground/80 px-3 py-1.5 text-xs font-medium text-background shadow-md backdrop-blur-sm animate-fade-in" style={{ animationDelay: "2s", animationFillMode: "backwards" }}>
        Chat with us
      </span>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_4px_20px_rgba(37,211,102,0.4)] hover:shadow-[0_6px_28px_rgba(37,211,102,0.5)] hover:scale-110 active:scale-95 transition-all"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="h-7 w-7" />
      </a>
    </div>
  );
};

export default WhatsAppButton;
